const WORDS = ["Vino", "Persone", "Territori", "Cantine", "Storie", "Horeca", "Vignaioli", "Calici", "Passione", "Italia"];

export default function Marquee({ light = false }) {
  const items = [...WORDS, ...WORDS];
  return (
    <div data-testid="editorial-marquee" className={`overflow-hidden py-6 border-y ${light ? "border-oro/20" : "border-bordeaux/20"} select-none`}>
      <div className="flex whitespace-nowrap animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {items.map((w, i) => (
              <span key={`${half}-${i}`} className={`flex items-center font-serif italic text-2xl sm:text-3xl ${light ? "text-panna/25" : "text-nero/15"}`}>
                <span className="px-6">{w}</span>
                <span className={`text-sm ${light ? "text-oro/50" : "text-bordeaux/50"}`}>◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
